import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LoginPage from './pages/login/LoginPage';
import TokenPage from './pages/login/TokenPage';
import RegistrationPage from './pages/register/RegistrationRoutes';
import { deleteData } from './lib/data';
import { UserContextProvider, UserContextConsumer } from './contexts/UserContext';
import DashboardPage from 'pages/main/pages/Dashboard/DashboardPage';
import NavigateComponent from 'pages/main/NavigateComponent';
import AuthWrapper from 'pages/main/AuthWrapper';
import UsersPage from 'pages/main/pages/Users/UsersPage';
import TagsPage from 'pages/main/pages/Tags/TagsPage';
import NoticesPage from 'pages/main/pages/Notices/NoticesPage';
import DepartmentsPage from 'pages/main/pages/Departments/DepartmentsPage';
import GroupsPage from 'pages/main/pages/Groups/GroupsPage';
import MicroLearningsPage from 'pages/main/pages/MicroLearning/MicroLearningsPage';
import ContentsPage from 'pages/main/pages/Contents/ContentsPage';
import ChallengesPage from 'pages/main/pages/Challenges/ChallengesPage';
import BillingPage from 'pages/main/pages/Billing/BillingPage';
import ReportsPage from 'pages/main/pages/Reports/ReportsPage';
import SettingsPage from 'pages/main/pages/Settings/SettingsPage';
import OrgsPage from 'pages/main/pages/Orgs/OrgsPage';
import KnowledgebaseCategoriesPage from 'pages/main/pages/Knowledgebase/KnowledgebaseCategoriesPage';
import KnowledgebaseListPageWithProps from './pages/main/pages/Knowledgebase/KnowledgebaseItemsListPage';
import CampaignsPageWithProps from './pages/main/pages/Campaigns/CampaignsPage';
import PromoBanner from './pages/main/pages/PromoBanner/PromoBannerPage';
import TrustSubmissionPage from 'pages/main/pages/TrustSubmission/TrustSubmissionPage';
import Logout from './pages/login/Logout';
import './pages/main/MainPage.css';
import OnboardingPageWithProps from 'pages/main/pages/Onboarding/OnboardingPage';
import { initGtm } from './gtm';

initGtm();

export const USER_ROLES = {
    NORMAL: 0,
    SUPER_USER: 1,
    ADMIN: 2,
    REPORTS: 3,
    FINANCE: 4,
    MANAGEMENT: 5,
    USER_MANAGEMENT: 6,
    CONTENT: 7,
    USER_SUBMITTER: 8,
};

export default class App extends React.Component {
    logout = (renderProps) => {
        deleteData('token', '', true);
        return <Navigate to={{ pathname: '/', state: { from: this.props.location } }} />;
    };

    render() {
        return (
            <UserContextProvider>
                {window.location.hostname.indexOf('dashboard.engage4.com') === -1 ? (
                    <Helmet>
                        <meta name="robots" content="noindex" />
                    </Helmet>
                ) : null}
                <div className="outer">
                    <div className="inner">
                        <Router>
                            <Routes>
                                <Route path="/register" element={<RegistrationPage />} />
                                <Route exact path="/register/user" element={<RegistrationPage />} />
                                <Route exact path="/register/complete" element={<RegistrationPage />} />
                                <Route path="/login" element={<LoginPage />} />
                                <Route path="/logout" element={<Logout />} />
                                <Route path="/token_auth" element={<TokenPage />}>
                                    <Route path="*" element={<TokenPage />} />
                                </Route>

                                {/*  Authenticated Routes */}
                                {/* <Route path="/" element={<NavigateComponent />} /> */}
                                <Route element={<AuthWrapper />}>
                                    <Route path="/dashboard" element={<DashboardPage />} />
                                    <Route exact path="/users" element={<UsersPage />} />
                                    <Route path="/users/list" element={<UsersPage />} />
                                    <Route path="/users/tags" element={<TagsPage />} />
                                    {({ user }) => {
                                        user.is_global && <Route path="/notices" element={<NoticesPage />} />;
                                    }}
                                    <Route path="/departments" element={<DepartmentsPage />} />
                                    <Route path="/campaigns" element={<CampaignsPageWithProps />} />
                                    <Route path="/PromoBanner" element={<PromoBanner />} />
                                    <Route path="/trust-submission" element={<TrustSubmissionPage />} />
                                    <Route path="/groups" element={<GroupsPage />} />
                                    <Route path="/micro" element={<MicroLearningsPage />} />
                                    <Route path="/content" element={<ContentsPage />} />
                                    <Route path="/challenges" element={<ChallengesPage />} />
                                    <Route exact path="/onboarding" element={<OnboardingPageWithProps />} />
                                    <Route exact path="/knowledgebase" element={<KnowledgebaseListPageWithProps />} />
                                    <Route
                                        path="/knowledgebase/manage-categories"
                                        element={<KnowledgebaseCategoriesPage />}
                                    />
                                    <Route exact path="/reports" element={<ReportsPage />} />
                                    <Route path="/billing" element={<BillingPage />} />
                                    <Route path="/settings" element={<SettingsPage />} />
                                    <Route path="/orgs" element={<OrgsPage />} />
                                    <Route path="/" element={<NavigateComponent />} />
                                </Route>
                            </Routes>
                        </Router>
                    </div>
                </div>
            </UserContextProvider>
        );
    }
}
